import getMeta from "./utils/get-meta";

export type { MetaGetter } from "./utils/get-meta";

export default getMeta;
